import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

const bluePalette = {
  ...palettes.light,
  primary: { main: '#3d5a80' },
  secondary: { main: '#0e3b73' },
  error: { main: '#d32f2f' },
  warning: { main: '#f57c00' },
  info: { main: '#4a6fa5' },
  success: { main: '#2e7d32' },
  background: {
    default: '#f5f7fa',
    paper: '#ffffff',
  },
  banner: {
    info: '#1e88e5',
    error: '#d32f2f',
    text: '#0a1f44',
    link: '#0e3b73',
  },
  errorBackground: '#ffebee',
  warningBackground: '#fff3e0',
  infoBackground: '#e3f2fd',
  navigation: {
    background: '#0a1f44',
    indicator: '#00e5ff',
    color: '#e3f7ff',
    selectedColor: '#ffffff',
  },
};

const commonColors = [bluePalette.primary.main, bluePalette.info.main];
const allPageKinds = [
  'home',
  'documentation',
  'tool',
  'service',
  'website',
  'library',
  'other',
  'app',
  'apis',
] as const;

export const myTheme2 = createUnifiedTheme({
  ...createBaseThemeOptions({ palette: bluePalette }),
  defaultPageTheme: 'home',
  fontFamily: 'DM Sans, sans-serif',
  pageTheme: Object.fromEntries(
    allPageKinds.map(kind => [
      kind,
      genPageTheme({ colors: commonColors, shape: shapes.wave }),
    ]),
  ) as Record<(typeof allPageKinds)[number], ReturnType<typeof genPageTheme>>,
  components: {
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          top: '80px',
        },
      },
    },
  },
});
